<template>
    <card-tabs v-if="contact" selected-name="contact">
        <template #labels>
            <card-tab-label name="contact">
                Contactpersoon
            </card-tab-label>

            <card-tab-label v-if="hasSecondaryContact" name="existing-partner">
                {{ contact.secondaryContact?.name.fullName || 'Partner' }}
            </card-tab-label>

            <button-text
                v-if="!hasSecondaryContact && props.editable"
                style="align-self: center;"
                @click="openPartnerEdit"
            >
                <svg-icon :icon="IconAdd" />
                <span>Partner toevoegen</span>
            </button-text>
        </template>

        <template #panels>
            <contact-card-panel
                :contact="contact as Contact"
                name="contact"
                variant="card"
                with-variable-height
                :editable="props.editable"
            />
            <contact-card-panel
                v-if="hasSecondaryContact && contact.secondaryContact"
                :contact="contact.secondaryContact as Contact"
                name="existing-partner"
                variant="card"
                with-variable-height
                :editable="props.editable"
            />
        </template>
    </card-tabs>
</template>

<script lang="ts" setup>
    import IconAdd from '@keyvue/one-material-icons/icons/add.svg?component';
    import { ButtonText, CardTabLabel, CardTabs, SvgIcon } from '@keyvue/one-ui';
    import { useRouter, useRoute, type RouteLocationRaw } from 'vue-router';
    import type { Contact, ContactId } from '@keyvue/one-api-client';
    import { computed } from 'vue';
    import ContactCardPanel from '@components/Tabs/Panels/ContactCardPanel.vue';
    import useContactPageData from '@composables/useContactPageData';

    export interface Props {
        contactId: ContactId
        editable?: boolean,
    }

    const props = defineProps<Props>();

    const router = useRouter();
    const route = useRoute();
    const contactPageData = useContactPageData(props.contactId.toString());

    // This card opens with the lead sheet, usually after the contact page loaded the contact; the
    // contact is then refreshed in the background, as the card loaded its own fresh copy before.
    const contact = await contactPageData.freshContact();
    const hasSecondaryContact = computed(() => !!contact.secondaryContact);

    const routeToContactEdit = computed(() => {
        const contactEditRoute: RouteLocationRaw = {
            name: 'contactEdit',
            params: {
                contactId: contact.id.toString(),
            },
        };

        if ('leadId' in route.params) {
            contactEditRoute.name = 'leadContactEdit';
            contactEditRoute.params = {
                ...contactEditRoute.params,
                leadId: route.params.leadId.toString(),
            };
        }

        if ('orderId' in route.params) {
            contactEditRoute.name = 'orderContactEdit';
            contactEditRoute.params = {
                ...contactEditRoute.params,
                orderId: route.params.orderId.toString(),
            };
        }

        return contactEditRoute;
    });

    const openPartnerEdit = () => {
        router.push({
            ...routeToContactEdit.value,
            query: {
                contact: 'partner',
            },
        });
    };
</script>
